<template>
	<ProgressSpinner v-if="!device"/>
	<Container class="pt-6 w-full h-screen flex flex-col" v-if="device">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">

			<Breadcrumb :home="home" :model="items" class="mb-3">
				<template #item="{ item, props }">
					<router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
						<a :href="href" v-bind="props.action" @click="navigate">
							<i :class="[item.icon, 'text-color']"/>
							<span class="text-surface-500 dark:text-surface-400 font-semibold">{{ item.label }}</span>
						</a>
					</router-link>
          <span v-else-if="item.action" @click="item.action" v-bind="props.action">
            <i :class="[item.icon, 'text-color']"/>
            <span class="text-surface-500 dark:text-surface-400 font-semibold">{{ item.label }}</span>
          </span>
				</template>
			</Breadcrumb>

			<PageHeading data-cy="device-serial-number-heading">{{ device.serial_number ?? $route.params.device }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<div class="flex-1 overflow-y-auto">
			<router-view
					@on-save="onSave"
					@on-delete="$emit('on-delete')"
					:device="device"
			></router-view>

		</div>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";
import Container from "@/Components/Container.vue";


export default {
	name: "DeviceView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			device: undefined,
			params: {
				include: [],
			},
			home: {
        icon: 'ti ti-home text-lg',
        route: { name: 'home'}
      },
		}
	},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.device === 'NEW') {
						this.device = {};
					} else {
						this.device = await this.fetchDevice();
					}
				} else {
					this.device = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useDevicesStore),
		tabs() {
			return [
				{
					label: this.$t('common.summary'),
					current: this.$route.name === 'devices.show',
					to: {name: 'devices.show', params: this.$route.params}
				},
				{
					label: this.$t('common.properties'),
					current: this.$route.name === 'devices.show.properties',
					to: {name: 'devices.show.properties', params: this.$route.params}
				},
				{
					label: this.$t('common.history'),
					current: this.$route.name === 'devices.show.history',
					to: {name: 'devices.show.history', params: this.$route.params}
				},
			]
		},
    items() {
      return [{
        icon: 'ti ti-arrow-back-up text-xl',
        label: this.$t('common.back'),
        action: () => this.$router.back(),
      }]
    }
	},
	methods: {
		async onSave() {
			this.device = await this.fetchDevice();
		},
		fetchDevice() {
			return this.devicesStore.showDevice(this.$route.params.device);
		}
	}
}
</script>
